import { isSchedulableDeviceStatus } from '@/utils/deviceStatus';
import { isIlrDevice } from '@/utils/deviceType';

export interface EriActionDevice {
  id?: string | null;
  type?: string | null;
  status?: unknown;
  isEriTracked?: boolean | null;
  vendor?: string | null;
  modelName?: string | null;
}

const VENDOR_LABELS: Record<string, string> = {
  medtronic: 'Medtronic',
  abbott: 'Abbott',
  biotronik: 'Biotronik',
  boston_scientific: 'Boston Scientific',
  sorin: 'Sorin'
};

/** Active, new implant, and pending devices that are not ILRs. */
export function eriEligibleDevices<T extends EriActionDevice>(
  devices: T[] | null | undefined
): T[] {
  return (devices ?? []).filter(
    (device) =>
      Boolean(device.id) && !isIlrDevice(device.type) && isSchedulableDeviceStatus(device.status)
  );
}

export function eriActionTargets<T extends EriActionDevice>(
  devices: T[]
): {
  start: T[];
  stop: T[];
} {
  return {
    start: devices.filter((device) => device.isEriTracked !== true),
    stop: devices.filter((device) => device.isEriTracked === true)
  };
}

export function eriDeviceLabel(device: EriActionDevice): string {
  const vendorKey = String(device.vendor ?? '').toLowerCase();
  const vendor = VENDOR_LABELS[vendorKey] ?? device.vendor;
  const label = [vendor, device.type, device.modelName].filter(Boolean).join(' ');
  return label || 'Device';
}
